/* eslint-disable no-console */
<template>
  <div>
    <div class="card z-depth-5 p-3">
      <h4 class="text-center font-weight-bold py-3">Students Report</h4>
      <div class="table-responsive">
        <table class="table table-bordered">
          <thead class="thead-dark">
            <tr>
              <th scope="col">Email</th>
              <th scope="col">First Name</th>
              <th scope="col">Last Name</th>
              <th scope="col">Logged In Time</th>
              <th scope="col">Track</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="student in students" :key="student._id">
              <th>{{ student.email }}</th>
              <th>{{ student.first_name }}</th>
              <td>{{ student.last_name }}</td>
              <td>{{ secondsToHms(student.emmaTime) }}</td>
              <td> <button class="btn btn-primary btn-sm" @click.prevent="clickedTrack(student)">Track</button></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <mdb-container>
        <mdb-modal :show="showModal" removeBackdrop centered size="xl">
            <mdb-modal-body>
              <h4 class="text-center font-weight-bold py-3">{{this.currentStudentName}}'s Report</h4>
      <div class="table-responsive">
        <table class="table table-bordered">
          <thead class="thead-dark">
            <tr>
              <th scope="col">Video ID</th>
              <th scope="col">Video Title</th>
              <th scope="col">Points</th>
              <th scope="col">Passing Time</th>
              <th scope="col">Updated At</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in progresses" :key="item._id">
              <th> <router-link :to="{name: 'Quizs', params: {videoId: item.lesson_id}}">{{ item.lesson_id }}</router-link></th>
              <th>{{ item.title }}</th>
              <td>{{ item.points  }} / {{ item.count }}</td>
              <td>{{ secondsToHms(item.time) }}</td>
              <td>{{ miliToDate(item.updated_at) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
                <div class="modal-footer">
                    <button
                          type="button"
                          class="btn btn-danger btn-sm"
                          data-dismiss="modal"
                          @click="showModal = false"
                        >
                          Close
                    </button>
                </div>
            </mdb-modal-body>
            </mdb-modal>
    </mdb-container>
  </div>
</template>

<script>
import axios from "axios";
import { mdbContainer, mdbModal, mdbModalBody } from "mdbvue";


export default {
  name: "StudentsReport",
  components: {
    mdbContainer,
    mdbModal,
    mdbModalBody,
  },
  data() {
    return {
      students: [],
      progresses: [],
      showModal: false,
      currentStudentName: '',
      fastAdminToken: localStorage.getItem("fastAdminToken"),
    };
  },
  methods: {
    secondsToHms(d) {
      d = Number(d);
      var h = Math.floor(d / 3600);
      var m = Math.floor(d % 3600 / 60);
      var s = Math.floor(d % 3600 % 60);

      var hDisplay = h > 0 ? h + (h == 1 ? " hour, " : " hours, ") : "";
      var mDisplay = m > 0 ? m + (m == 1 ? " minute, " : " minutes, ") : "";
      var sDisplay = s > 0 ? s + (s == 1 ? " second" : " seconds") : "";
      return hDisplay + mDisplay + sDisplay; 
    },

    miliToDate(milis) {
      var date = new Date(milis);
      return date.toLocaleString();
    },

    clickedTrack(student) {

      this.currentStudentName = student.first_name + ' ' + student.last_name + `(${student.email})`;



      this.progresses = [];
      this.$toast.open({
        message: "Processing : Loading Students Data Please Wait...",
        type: "info",
      });

    const config = {
      headers: {
        Authorization: "Bearer " + this.fastAdminToken,
        "Content-Type": "application/json",
      },
    };
    axios
      .get(this.$apiURI + "/emmaprogress/user/" + student._id, config)
      .then((response) => {
        if (response.data.error) {
          this.$toast.open({
            message: "Error : " + response.data.message,
            type: "error",
          });
        } else {
          // eslint-disable-next-line no-console
          // console.log(response.data.data.teachers)
          this.progresses = response.data.data.progresses;
          this.showModal = true;
        }
      })
      .catch((error) => {
        this.$toast.open({
          message: "Error : " + error.response.data.message,
          type: "error",
        });
      });

    }
  },
  mounted() {
    this.$toast.open({
      message: "Processing : Loading Students Data Please Wait...",
      type: "info",
    });

    const config = {
      headers: {
        Authorization: "Bearer " + this.fastAdminToken,
        "Content-Type": "application/json",
      },
    };
    axios
      .get(this.$apiURI + "/account/students", config)
      .then((response) => {
        if (response.data.error) {
          this.$toast.open({
            message: "Error : " + response.data.message,
            type: "error",
          });
        } else {
          // eslint-disable-next-line no-console
          // console.log(response.data.data.teachers)
          this.students = response.data.data.students.sort((a, b) => b.emmaTime - a.emmaTime);
        }
      })
      .catch((error) => {
        this.$toast.open({
          message: "Error : " + error.response.data.message,
          type: "error",
        });
      });

   
  },
};
</script>
